import i18n from "i18next";

import { ConfirmationModal } from "../../Modal/ConfirmationModal";
import { useConfirmationButtonHandler } from "../hooks/useConfirmationButtonHandler";
import type { ModalButtonComponentProps } from "../types/GenericConfirmationButtonProps";
import { PrimaryButton } from "./ActionButton";

export const GenericConfirmationPrimaryButton = (props: ModalButtonComponentProps) => {
    const [name, isModalVisible, onOk, onCancel, onClick, modalTitle, modalBody, params, isDisabled, buttonTransKey] =
        useConfirmationButtonHandler(props);

    return (
        <>
            <ConfirmationModal
                visible={isModalVisible}
                title={i18n.t(modalTitle)}
                onOk={onOk}
                onCancel={onCancel}
                message={i18n.t(modalBody, params)}
            />
            <PrimaryButton name={name} onClick={onClick} disabled={isDisabled}>
                {buttonTransKey && i18n.t(buttonTransKey)}
            </PrimaryButton>
        </>
    );
};
